export enum SalePatternSchedule {
    Weekly = 'Weekly',
    Monthly = 'Monthly',
    TwoMonths = 'TwoMonths',
    ThreeMonths = 'ThreeMonths',
    FourMonths = 'FourMonths',
    FiveMonths = 'FiveMonths',
    SixMonths = 'SixMonths',
    Yearly = 'Yearly',
}

export type SalePatternScheduleRepetitionSkip = 1 | 2 | 3 | 4 | 5 | 6;

export const monthlyScheduleKinds: SalePatternSchedule[] = [
    SalePatternSchedule.Monthly, SalePatternSchedule.TwoMonths,
    SalePatternSchedule.ThreeMonths, SalePatternSchedule.FourMonths,
    SalePatternSchedule.FiveMonths, SalePatternSchedule.SixMonths];
